class GrFaqList extends HTMLElement {
  connectedCallback() {
    this.addEventListener('toggle', this.#onToggle, true);
  }

  disconnectedCallback() {
    this.removeEventListener('toggle', this.#onToggle, true);
  }

  #onToggle = (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.open) return;

    this.querySelectorAll('details[open]').forEach((openItem) => {
      if (openItem !== item) openItem.open = false;
    });
  };
}

if (!customElements.get('gr-faq-list')) {
  customElements.define('gr-faq-list', GrFaqList);
}
